import './show-more.less';
import { getProductData } from '../../../pages/pdp/utils/data';
import { onSwitchToDesktop, onSwitchFromDesktop } from '../../../utils/resizeObserver';
import { isNotDesktop } from '../../../utils/isNotDesktop';

export const GLOBAL_DESKTOP_TAB_HEIGHT = 680;
export const GLOBAL_MOBILE_TAB_HEIGHT = 580;
export const LOCAL_DESKTOP_TAB_HEIGHT = 480;
export const LOCAL_MOBILE_TAB_HEIGHT = 370;
export const ELEMENT_HEIGHT_TOLERANCE = 30;

let currentTabHeight = GLOBAL_DESKTOP_TAB_HEIGHT;

const getTabElement = element =>
    element.querySelector('.tab-content') || element.querySelector('.tab-content-section');
const getTabHeight = () => currentTabHeight;

const shouldAppendShowMore = element => {
    const shouldAppend =
        element.getBoundingClientRect().height > getTabHeight() + ELEMENT_HEIGHT_TOLERANCE;
    return shouldAppend;
};

const showMoreEventHandler = ({ target }) => {
    const element = target.classList.contains('tabs-show-more__title')
        ? target.parentElement
        : target;
    // eslint-disable-next-line no-use-before-define
    removeShowMore(element);
};

export const removeShowMore = element => {
    const isArgumentButton = element.classList.contains('tabs-show-more');
    const buttonElement = isArgumentButton ? element : element.querySelector('.tabs-show-more');
    const tabContentElement = isArgumentButton ? buttonElement.parentElement : element;
    tabContentElement.style.height = 'auto';
    buttonElement.removeEventListener('click', showMoreEventHandler);
    tabContentElement.removeChild(buttonElement);
};

const initShowMore = ({ element, showMoreTitle }) => {
    const showMoreButton = document.createElement('button');
    const showMoreSpan = document.createElement('span');

    showMoreButton.className = 'tabs-show-more';
    showMoreSpan.className = 'tabs-show-more__title';
    showMoreSpan.innerText = showMoreTitle;
    showMoreButton.appendChild(showMoreSpan);

    showMoreButton.addEventListener('click', showMoreEventHandler);

    element.appendChild(showMoreButton);
};

const setTabHeight = (height, currentTabs) => {
    currentTabHeight = height;
    currentTabs.forEach(el => {
        const showMoreButton = el.querySelector('.tabs-show-more');
        if (showMoreButton) {
            el.style.height = `${height}px`;
        }
    });
};

export const appendShowMore = (elements, config = {}) => {
    const { desktop, mobile } = {
        desktop: GLOBAL_DESKTOP_TAB_HEIGHT,
        mobile: GLOBAL_MOBILE_TAB_HEIGHT,
        ...config,
    };
    const showMoreTitle = getProductData().showMore;
    const tabElements = elements.map(getTabElement).filter(Boolean);
    tabElements.forEach(currentTab => {
        if (shouldAppendShowMore(currentTab)) {
            initShowMore({ element: currentTab, showMoreTitle });
            const computedTabHeight = isNotDesktop() ? mobile : desktop;
            setTabHeight(computedTabHeight, [currentTab]);
        }
    });

    onSwitchToDesktop(() => setTabHeight(desktop, tabElements));
    onSwitchFromDesktop(() => setTabHeight(mobile, tabElements));
};
